import { useDateFieldState } from '../../DateField';
import { createPlaceholderValue, mergeDateTime } from '../../utils/dates';
import { getDateTimeValue } from '../utils';
import { datePickerStateFactory } from './datePickerStateFactory';
export const useDatePickerState = datePickerStateFactory({
    getPlaceholderTime,
    mergeDateTime,
    setTimezone: (date, timeZone) => date.timeZone(timeZone),
    getDateTime: getDateTimeValue,
    useDateFieldState,
});
function getPlaceholderTime(placeholderValue, timeZone) {
    return createPlaceholderValue({ placeholderValue, timeZone });
}
